import * as React from 'react';
import { getAllUpcomingAuctionsUrl, getAuctioneerDirectoryUrl, getAuctionResultsUrl, getTodayUrl } from '@/utils/urls';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faFire } from '@fortawesome/pro-regular-svg-icons/faFire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import Popover from '@liveauctioneers/caterwaul-components/lib/Popover/Popover';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { trackPastAuctionResultsClick } from '@/redux/modules/analytics';
import { useDispatch } from 'react-redux';

const FindAuctions = () => {
    const dispatch = useDispatch();
    const track = React.useCallback(() => {
        dispatch(trackPastAuctionResultsClick());
    }, [dispatch]);

    return (
        <Popover
            childrenClickClosesPopover
            disableBottomPlacementFallbacks
            hoverShowDelay={200}
            placement="bottom"
            trigger={
                <StyledTriggerText colorBlue>
                    <FormattedMessage id="find_auctions" />
                    <StyledCaretFAI icon={faCaretDown} />
                </StyledTriggerText>
            }
        >
            <StyledContent>
                <StyledNavigationLink route to={getAllUpcomingAuctionsUrl()}>
                    <FormattedMessage id="auction_calendar" />
                    <StyledListFAI icon={faCalendarAlt} />
                </StyledNavigationLink>
                <StyledNavigationLink route to="/find-auctions-near-me">
                    <FormattedMessage id="auctions_near_me" />
                </StyledNavigationLink>
                <StyledNavigationLink route to={getTodayUrl()}>
                    <FormattedMessage id="trending_auctions" />
                    <StyledListFAI icon={faFire} />
                </StyledNavigationLink>
                <StyledNavigationLink route to={getAuctioneerDirectoryUrl()}>
                    <FormattedMessage id="auction_house_directory" />
                </StyledNavigationLink>
                <StyledNavigationLink onClick={track} route to={getAuctionResultsUrl()}>
                    <FormattedMessage id="past_auction_results" />
                </StyledNavigationLink>
            </StyledContent>
        </Popover>
    );
};

export default React.memo(FindAuctions);

const StyledTriggerText = styled(Text)`
    && {
        text-decoration: none;
        padding: 10px 8px 10px 0;
        cursor: pointer;
        line-height: 33px;

        /* special case, this needs to match the font and size of other navigation. */
        font-family: ${({ theme }) => theme.typography.fontSecondary};

        @media (max-width: 976px) {
            font-size: 14px;
        }
    }
`;

const StyledCaretFAI = styled(FontAwesomeIcon)`
    margin-left: 10px;
    height: 16px;
    width: 10px;
`;

const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 0;
`;

const StyledNavigationLink = styled(Link)`
    && {
        /* Link and text don't play well together. OP-621 is to fix that */
        color: ${({ theme }) => theme.colors.grey100};
        cursor: pointer;
        font-family: ${({ theme }) => theme.typography.fontPrimary};
        font-size: 14px;
        letter-spacing: 0.5px;
        line-height: 43px;
        padding: 2px 20px;
        text-align: left;
        text-decoration: none;

        :hover {
            color: ${({ theme }) => theme.colors.blue200};
            background-color: ${({ theme }) => theme.colors.grey500};
        }
    }
`;

const StyledListFAI = styled(FontAwesomeIcon)`
    margin-left: 10px;
    height: 16px;
    width: 16px;
`;
